/**
 * SYSTEM_ADMIN が「表示中の自治体」を切り替えるためのグローバル状態。
 *
 * - 保存先は sessionStorage（タブ単位・リロードで保持。Cognito トークンと同じ per-tab スコープに揃える）。
 * - 値は選択中の自治体 id。未選択（= 全自治体横断）のときはキー自体を削除する。
 * - この値は API クライアントの共通インターセプタが {@link ACTING_MUNICIPALITY_HEADER} として全リクエストに付与し、
 *   後端は DB 由来ロールが SYSTEM_ADMIN のときのみ信用する（非管理者が送っても無視される）。
 *
 * 反映方式: 本アプリは react-query 等の共有キャッシュを持たず各画面が自前で fetch するため、
 * 切替時は {@link setActingMunicipalityId} 呼び出し後に画面側でリロードして全画面を確実に再取得させる。
 */
export const ACTING_MUNICIPALITY_HEADER = 'X-Acting-Municipality-Id'

const STORAGE_KEY = 'pams.actingMunicipalityId'

function hasSessionStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'
}

/** 現在選択中の自治体 id。未選択（全自治体）なら null。 */
export function getActingMunicipalityId(): number | null {
  if (!hasSessionStorage()) return null
  const raw = window.sessionStorage.getItem(STORAGE_KEY)
  if (raw == null || raw === '') return null
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
}

/** 選択中の自治体を設定する。null / 0 以下は「未選択（全自治体）」としてキーを削除する。 */
export function setActingMunicipalityId(id: number | null): void {
  if (!hasSessionStorage()) return
  if (id == null || id <= 0) {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } else {
    window.sessionStorage.setItem(STORAGE_KEY, String(id))
  }
}
